
import { Component, Vue } from "vue-property-decorator";
import LsDialog from "@/components/ls-dialog.vue";
import LsPagination from "@/components/ls-pagination.vue";
import ExportData from "@/components/export-data/index.vue";
import {
  apiWorkorderList,
  apiWorkorderEnum,
  apiWorkorderDetail,
  apiWorkorderReply,
  apiWorkorderChangeStatus,
  apiWorkorderAssignAdmin,
  apiWorkorderStatistics,
} from "@/api/workorder";
import { RequestPaging } from "@/utils/util";
import MaterialSelect from "@/components/material-select/index.vue";
import PopoverInput from "@/components/popover-input.vue";

@Component({
  components: {
    LsDialog,
    LsPagination,
    ExportData,
    MaterialSelect,
    PopoverInput,
  },
})
export default class WorkorderLists extends Vue {
  /** S Data **/

  // 分页
  pager: RequestPaging = new RequestPaging();
  priorityList: any[] = [];
  statusList: any[] = [];
  typeList: any[] = [];
  searchForm: any = {
    type: "",
    status: "",
    title: "",
  };
  dialogVisible: boolean = false;
  modelForm: any = {};
  replyDialog: boolean = false;
  replyForm: any = {
    content: "",
    images: "",
    id: "",
  };
  statusDialog: boolean = false;
  statusForm: any = {
    priority: "",
    admin_remark: "",
    status: "",
    id: "",
  };
  /** E Data **/

  /** S Methods **/

  // 获取资讯文章列表
  getList() {
    this.pager
      .request({
        callback: apiWorkorderList,
        params: {
          ...this.searchForm,
        },
      })
      .catch((err: any) => {
        console.log("err", err);
      });
  }

  // 获取工单类型
  getWorkorderEnum() {
    apiWorkorderEnum().then((res: any) => {
      this.priorityList = res.priority;
      this.statusList = res.status;
      this.typeList = res.type;
    });
  }

  // 获取工单详情
  getWorkorderDetail(id: string) {
    apiWorkorderDetail({ id }).then((res: any) => {
      this.modelForm = res;
      this.dialogVisible = true;
    });
  }

  showReplyDialog(row: any) {
    this.replyForm.id = row.id;
    this.replyDialog = true;
  }

  handleSubmitReply() {
    apiWorkorderReply(this.replyForm).then((res: any) => {
      console.log("res", res);
      this.replyDialog = false;
      this.getList();
    });
  }

  showStatusDialog(row: any) {
    this.statusForm.id = row.id;
    this.statusDialog = true;
  }

  handleSubmitStatus() {
    apiWorkorderChangeStatus(this.statusForm).then((res: any) => {
      console.log("res", res);
      this.statusDialog = false;
      this.getList();
    });
  }

  // 指定管理员处理
  submitAssignAdmin(val: string, id: any) {
    apiWorkorderAssignAdmin({ platform_admin_id: val, id }).then((res: any) => {
      this.getList();
    });
  }
  /** E Methods **/

  /** S Life Cycle **/
  created() {
    apiWorkorderStatistics().then((res: any) => {
      console.log("res", res);
    });
    this.getWorkorderEnum();
    this.getList();
  }

  /** E Life Cycle **/
}
